let registeredRoutes = []

const collectPaths = (routes, result = []) => {
  if (!Array.isArray(routes)) return result
  routes.forEach((route) => {
    if (typeof route?.path === 'string' && route.path) {
      result.push(route.path)
    }
    if (route?.routes) collectPaths(route.routes, result)
    if (route?.children) collectPaths(route.children, result)
  })
  return result
}

export const setRegisteredRoutes = (routes) => {
  registeredRoutes = routes
  if (
    typeof window === 'undefined' ||
    !window.parent ||
    window.location.pathname !== '/__routes'
  ) {
    return
  }
  window.parent.postMessage(
    {
      type: 'HIYA_WEB_ROUTES',
      routes: collectPaths(registeredRoutes),
    },
    '*'
  )
}

export const getRegisteredRoutePaths = () => collectPaths(registeredRoutes)
